import {
  Dismiss20Regular,
  Checkmark20Regular,
  ChevronDown20Regular,
} from "@fluentui/react-icons";
import { useState } from "react";

interface ExportarFornecedoresModalProps {
  isOpen: boolean;
  onClose: () => void;
  totalFornecedoresFiltrados?: number;
}

export function ExportarFornecedoresModal({
  isOpen,
  onClose,
  totalFornecedoresFiltrados = 0,
}: ExportarFornecedoresModalProps) {
  const [alcance, setAlcance] = useState<
    "todos" | "filtrados"
  >("todos");
  const [formato, setFormato] = useState<"xlsx" | "csv">(
    "xlsx",
  );
  const [isFormatoDropdownOpen, setIsFormatoDropdownOpen] =
    useState(false);

  const [conteudo, setConteudo] = useState({
    dadosFornecedor: true,
    contactoPrincipal: true,
    condicoesComerciais: true,
    categoria: true,
    notasInternas: true,
    compras: true,
  });

  const handleExportar = () => {
    console.log("Exportar:", { alcance, conteudo, formato });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50"
        onClick={onClose}
      />

      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div
          className="bg-card border border-border shadow-lg w-full max-w-[560px] max-h-[90vh] flex flex-col"
          style={{ borderRadius: "var(--radius-card)" }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-8 pb-6 border-b border-border">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h2
                  className="text-foreground"
                  style={{
                    fontSize: "var(--text-large)",
                    fontWeight: "var(--font-weight-semi-bold)",
                    lineHeight: "1.3",
                  }}
                >
                  Exportar Fornecedores
                </h2>
                <p
                  className="text-secondary-text mt-2"
                  style={{ fontSize: "var(--text-base)" }}
                >
                  Escolha o que pretende incluir na exportação.
                </p>
              </div>
              <button
                onClick={onClose}
                className="ml-4 p-2 hover:bg-accent rounded transition-colors"
                style={{ borderRadius: "var(--radius)" }}
              >
                <Dismiss20Regular className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-8 space-y-8">
            <div className="space-y-4">
              <h3
                className="text-foreground"
                style={{
                  fontSize: "var(--text-section-title)",
                  fontWeight: "var(--font-weight-semi-bold)",
                }}
              >
                Alcance da Exportação
              </h3>

              <div className="space-y-3">
                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="radio"
                      name="alcance"
                      checked={alcance === "todos"}
                      onChange={() => setAlcance("todos")}
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded-full checked:border-primary checked:border-[6px] transition-all"
                      style={{
                        accentColor: "var(--primary)",
                      }}
                    />
                  </div>
                  <div className="flex-1">
                    <span
                      className="text-foreground"
                      style={{ fontSize: "var(--text-base)" }}
                    >
                      Todos os fornecedores
                    </span>
                  </div>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="radio"
                      name="alcance"
                      checked={alcance === "filtrados"}
                      onChange={() => setAlcance("filtrados")}
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded-full checked:border-primary checked:border-[6px] transition-all"
                      style={{
                        accentColor: "var(--primary)",
                      }}
                    />
                  </div>
                  <div className="flex-1">
                    <span
                      className="text-foreground"
                      style={{ fontSize: "var(--text-base)" }}
                    >
                      Apenas fornecedores filtrados{" "}
                      <span className="text-secondary-text">
                        ({totalFornecedoresFiltrados} resultados)
                      </span>
                    </span>
                  </div>
                </label>
              </div>
            </div>

            <div className="space-y-4">
              <h3
                className="text-foreground"
                style={{
                  fontSize: "var(--text-section-title)",
                  fontWeight: "var(--font-weight-semi-bold)",
                }}
              >
                Conteúdo a Incluir
              </h3>

              <div className="space-y-3">
                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="checkbox"
                      checked={conteudo.dadosFornecedor}
                      onChange={(e) =>
                        setConteudo({
                          ...conteudo,
                          dadosFornecedor: e.target.checked,
                        })
                      }
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded checked:bg-primary checked:border-primary transition-all"
                      style={{ borderRadius: "var(--radius)" }}
                    />
                    {conteudo.dadosFornecedor && (
                      <Checkmark20Regular className="w-4 h-4 text-primary-foreground absolute pointer-events-none" />
                    )}
                  </div>
                  <span
                    className="text-foreground flex-1"
                    style={{ fontSize: "var(--text-base)" }}
                  >
                    Dados do Fornecedor
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="checkbox"
                      checked={conteudo.contactoPrincipal}
                      onChange={(e) =>
                        setConteudo({
                          ...conteudo,
                          contactoPrincipal: e.target.checked,
                        })
                      }
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded checked:bg-primary checked:border-primary transition-all"
                      style={{ borderRadius: "var(--radius)" }}
                    />
                    {conteudo.contactoPrincipal && (
                      <Checkmark20Regular className="w-4 h-4 text-primary-foreground absolute pointer-events-none" />
                    )}
                  </div>
                  <span
                    className="text-foreground flex-1"
                    style={{ fontSize: "var(--text-base)" }}
                  >
                    Contacto Principal
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="checkbox"
                      checked={conteudo.condicoesComerciais}
                      onChange={(e) =>
                        setConteudo({
                          ...conteudo,
                          condicoesComerciais: e.target.checked,
                        })
                      }
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded checked:bg-primary checked:border-primary transition-all"
                      style={{ borderRadius: "var(--radius)" }}
                    />
                    {conteudo.condicoesComerciais && (
                      <Checkmark20Regular className="w-4 h-4 text-primary-foreground absolute pointer-events-none" />
                    )}
                  </div>
                  <span
                    className="text-foreground flex-1"
                    style={{ fontSize: "var(--text-base)" }}
                  >
                    Condições Comerciais
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="checkbox"
                      checked={conteudo.categoria}
                      onChange={(e) =>
                        setConteudo({
                          ...conteudo,
                          categoria: e.target.checked,
                        })
                      }
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded checked:bg-primary checked:border-primary transition-all"
                      style={{ borderRadius: "var(--radius)" }}
                    />
                    {conteudo.categoria && (
                      <Checkmark20Regular className="w-4 h-4 text-primary-foreground absolute pointer-events-none" />
                    )}
                  </div>
                  <span
                    className="text-foreground flex-1"
                    style={{ fontSize: "var(--text-base)" }}
                  >
                    Categoria
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="checkbox"
                      checked={conteudo.notasInternas}
                      onChange={(e) =>
                        setConteudo({
                          ...conteudo,
                          notasInternas: e.target.checked,
                        })
                      }
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded checked:bg-primary checked:border-primary transition-all"
                      style={{ borderRadius: "var(--radius)" }}
                    />
                    {conteudo.notasInternas && (
                      <Checkmark20Regular className="w-4 h-4 text-primary-foreground absolute pointer-events-none" />
                    )}
                  </div>
                  <span
                    className="text-foreground flex-1"
                    style={{ fontSize: "var(--text-base)" }}
                  >
                    Notas Internas
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <div className="relative flex items-center justify-center mt-0.5">
                    <input
                      type="checkbox"
                      checked={conteudo.compras}
                      onChange={(e) =>
                        setConteudo({
                          ...conteudo,
                          compras: e.target.checked,
                        })
                      }
                      className="w-5 h-5 cursor-pointer appearance-none border-2 border-border rounded checked:bg-primary checked:border-primary transition-all"
                      style={{ borderRadius: "var(--radius)" }}
                    />
                    {conteudo.compras && (
                      <Checkmark20Regular className="w-4 h-4 text-primary-foreground absolute pointer-events-none" />
                    )}
                  </div>
                  <span
                    className="text-foreground flex-1"
                    style={{ fontSize: "var(--text-base)" }}
                  >
                    Compras Realizadas
                  </span>
                </label>
              </div>
            </div>

            <div className="space-y-4">
              <h3
                className="text-foreground"
                style={{
                  fontSize: "var(--text-section-title)",
                  fontWeight: "var(--font-weight-semi-bold)",
                }}
              >
                Formato do ficheiro
              </h3>

              <div className="relative">
                <button
                  type="button"
                  onClick={() =>
                    setIsFormatoDropdownOpen(!isFormatoDropdownOpen)
                  }
                  className="w-full px-4 py-2 border border-border rounded bg-background text-foreground flex items-center justify-between"
                  style={{ borderRadius: "var(--radius-button)" }}
                >
                  <span>{formato.toUpperCase()}</span>
                  <ChevronDown20Regular className="w-5 h-5 text-secondary-text" />
                </button>

                {isFormatoDropdownOpen && (
                  <div
                    className="absolute z-10 w-full mt-2 bg-card border border-border shadow-md"
                    style={{ borderRadius: "var(--radius-card)" }}
                  >
                    <button
                      type="button"
                      onClick={() => {
                        setFormato("xlsx");
                        setIsFormatoDropdownOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left hover:bg-accent"
                    >
                      XLSX
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setFormato("csv");
                        setIsFormatoDropdownOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left hover:bg-accent"
                    >
                      CSV
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="p-6 border-t border-border flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-secondary hover:bg-accent border border-border rounded transition-colors"
              style={{ borderRadius: "var(--radius-button)" }}
            >
              Cancelar
            </button>
            <button
              onClick={handleExportar}
              className="px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded transition-colors"
              style={{ borderRadius: "var(--radius-button)" }}
            >
              Exportar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
